export default __webpack_public_path__ + "static/media/Arrow_right_fill.7a4ab064.svg";